import hasFullName from './hasFullName';

const hasAuthor = (includedAuthor) => {
  return {
    author: Object.assign(
      { ...includedAuthor },
      hasFullName(includedAuthor),
    ),
  };
};

export default hasAuthor;
